/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function CircleIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "circle", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 8, stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(CircleIcon);
export default ForwardRef;
//# sourceMappingURL=circleIcon.js.map